import { render, staticRenderFns } from "./base_amount.vue?vue&type=template&id=24718419&"
import script from "./base_amount.vue?vue&type=script&lang=js&"
export * from "./base_amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports